exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps__rail-y{z-index:1015!important}.v-hl-btn-next{transform:translateX(10%)!important}.v-hl-btn-prev{transform:translateX(-10%)!important}.desktopPopup .vm--modal{top:0!important;left:0!important;width:100%!important;height:100%!important;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.4);border-radius:0;box-shadow:none}.desktopPopup .welcome-modal-main{top:130px}", ""]);

// exports
